/**
 * Formateo de tiempos. Había tres copias de este cálculo en la web (con
 * semánticas distintas: "12s" en una pantalla y "0:12" en otra, para el mismo
 * dato). Esta es la única implementación.
 */

/** Formatea milisegundos como `12s` o `1:05` (minutos:segundos). */
export const formatDuration = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes > 0 ? `${minutes}:${String(seconds).padStart(2, '0')}` : `${seconds}s`;
};
